import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppWrapper from "./Route/AppWrapper";
import { Provider } from "react-redux";
import { store, persistor } from "./Redux/store";
import { PersistGate } from "redux-persist/integration/react";
import Loading from "./Components/Loading";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "./Components/ErrorFallback";

export default function AppRoot() {
  return (
    <Provider store={store}>
      <PersistGate loading={<div style={{height: "100vh"}}><Loading/></div>} persistor={persistor}>
        <Router>
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <AppWrapper />
          </ErrorBoundary>
        </Router>
      </PersistGate>
    </Provider>
  );
}